import { Component, input } from '@angular/core';
import { DownloadDirective, FileSizePipe, Icon } from '@malirang/front-share';

@Component({
  selector: 'app-content-document',
  template: `
    <button
      download
      [fileName]="file()?.name || file()?.filename"
      [fileUrl]="file()?.url"
      class="rounded-xl flex border overflow-hidden w-full items-center bg-gray-50 group"
    >
      <div class="p-2.5 flex items-center justify-center h-full min-w-[64px]">
        <app-icon
          name="solar:folder-with-files-bold-duotone"
          class="!size-5 text-gray-400"
        />
      </div>
      <div
        class="p-3 flex w-full justify-between items-center bg-white group-hover:bg-gray-50 transition-colors"
      >
        <div class="flex flex-col gap-1 items-start">
          <p class="text-gray-800 text-sm">
            {{ file()?.name || file()?.filename }}
          </p>
          <p class="text-gray-400 text-xs">
            {{ file()?.size | fileSize }}
          </p>
        </div>
        <app-icon
          name="solar:download-minimalistic-bold"
          class="!size-5 text-gray-400"
        />
      </div>
    </button>
  `,
  imports: [DownloadDirective, Icon, FileSizePipe],
})
export class ContentDocumentComponent {
  file = input<any>();
}
